import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";

export function PageHeader(){
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <Link
          to={`/campaigns`}
          className="inline-flex items-center justify-center h-8 w-8 rounded-md border border-input bg-background hover:bg-accent hover:text-accent-foreground"
        >
          <ArrowLeft className="w-4 h-4" />
        </Link>
        <div>
          <h1 className="text-heading font-bold text-gray-900">Agent Configuration</h1>
          <p className="text-detail text-gray-600">
            Configure LLM, voice, and engine settings for this agent
          </p>
        </div>
      </div>
    </div>
  );
}